import theme from './theme.red';
const appColor = theme.primaryColor;
export default [{
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "S\u00f8r-Fron, Hundorp, Nordre \u00d8verbygda. G\u00e5rden Ommundgaard i Kvarvvegen 14, nevnt som Amundg\u00e5rd p\u00e5 bildet.",
    "url": "https:\/\/digitaltmuseum.no\/021017358099",
    "uniqueId": "021017358099",
    "imageUrl": "https:\/\/dms06.dimu.org\/image\/032ynU6itJXY?dimension=57x57-crop"
  }],
  "messagesCount": 12,
  "messages": [{
    "message": "S\u00e5 moro \u00e5 se, her tror jeg min mormor bodde som sm\u00e5jente.",
    "author": {
      "name": "Siv ",
      "imageUrl": null,
      "email": "sivragnhild@yahoo.no"
    },
    "createdAt": "2019-10-12T20:39:00+00:00",
    "subject": "S\u00f8r-Fron, Hundorp, Nordre \u00d8verbygda. G\u00e5rden Ommundgaard i Kvarvvegen 14, nevnt som Amundg\u00e5rd p\u00e5 bildet.",
    "uniqueId": "100070",
    "status": "open"
  }],
  "title": "S\u00f8r-Fron, Hundorp, Nordre \u00d8verbygda. G\u00e5rden Ommundgaard i Kvarvvegen 14, nevnt som Amundg\u00e5rd p\u00e5 bildet.",
  "inboxType": "comment",
  "createdAt": "2019-10-12T20:39:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-10-12T20:39:00+00:00",
  "uniqueId": "021017358099",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Buebru over elv med sporvogn i bakgrunnen",
    "url": "https:\/\/digitaltmuseum.no\/021017862612",
    "uniqueId": "021017862612",
    "imageUrl": "https:\/\/dms06.dimu.org\/image\/0331wxL9G1D1?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette bildet er fra K\u00f8benhavn. Brua til h\u00f8yre er Stormbroen og trikken er p\u00e5 vei inn i den gata som mange \u00e5r seinere fikk navnet Vindebrogade. Elva er ingen elv, men Frederikholms kanal. Det buede bygget til h\u00f8yre er en del Nationalmuseet (i Danmark). Helt til venstre en snipp av Thorvaldsens museum. Trikken er en s\u00e5kalt hovedtypevogn levert 1901 - 1907 (265 vogner). De m\u00f8rke skiltfargene tyder p\u00e5 at det er linje 6.",
    "author": {
      "name": "Bj\u00f8rn Andersen",
      "imageUrl": null,
      "email": "b.andersen@oslo.online.no"
    },
    "createdAt": "2019-10-09T05:35:00+00:00",
    "subject": "Buebru over elv med sporvogn i bakgrunnen",
    "uniqueId": "99957",
    "status": "open"
  }],
  "title": "Buebru over elv med sporvogn i bakgrunnen",
  "inboxType": "comment",
  "createdAt": "2019-10-09T05:35:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-10-09T05:35:00+00:00",
  "uniqueId": "021017862612",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Svarga, Marcello Haugens hjem",
    "url": "https:\/\/digitaltmuseum.no\/021018276029",
    "uniqueId": "021018276029",
    "imageUrl": "https:\/\/dms02.dimu.org\/image\/02346xTqWXc9?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Er det mulig \u00e5 bes\u00f8ke Svarga,Sameti den 5. oktober? Med vennlig hilsen Eli-Marie Fallet",
    "author": {
      "name": "Eli-Marie Fallet",
      "imageUrl": null,
      "email": "elfallet@bbnett.no"
    },
    "createdAt": "2019-09-13T09:38:00+00:00",
    "subject": "Svarga, Marcello Haugens hjem",
    "uniqueId": "8005",
    "status": "open"
  }],
  "title": "Svarga, Marcello Haugens hjem",
  "inboxType": "inquiry",
  "createdAt": "2019-09-13T09:38:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-13T09:38:00+00:00",
  "uniqueId": "021018276029",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ukjente g\u00e5rdsbruk, elv, trolig \u00d8stre Gausdal",
    "url": "https:\/\/digitaltmuseum.no\/021016839216",
    "uniqueId": "021016839216",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/032yiz9ioSvr?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Enkenhus",
    "author": {
      "name": "Veronica Andresen Jensen",
      "imageUrl": null,
      "email": "veronica.andresen@gmail.com"
    },
    "createdAt": "2019-10-06T00:08:00+00:00",
    "subject": "Ukjente g\u00e5rdsbruk, elv, trolig \u00d8stre Gausdal",
    "uniqueId": "99903",
    "status": "open"
  }],
  "title": "Ukjente g\u00e5rdsbruk, elv, trolig \u00d8stre Gausdal",
  "inboxType": "comment",
  "createdAt": "2019-10-06T00:08:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-10-06T00:08:00+00:00",
  "uniqueId": "021016839216",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Repro: Krigsfanger, britiske og norske?",
    "url": "https:\/\/digitaltmuseum.no\/021018415308",
    "uniqueId": "021018415308",
    "imageUrl": "https:\/\/dms03.dimu.org\/image\/02348wexCKQn?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Hjelmene er av britisk modell, likes\u00e5 uniformen til de med hjelm.",
    "author": {
      "name": "Ivar Stav",
      "imageUrl": null,
      "email": "ivar.es@online.no"
    },
    "createdAt": "2019-10-04T08:08:00+00:00",
    "subject": "Repro: Krigsfanger, britiske og norske?",
    "uniqueId": "99864",
    "status": "open"
  }],
  "title": "Repro: Krigsfanger, britiske og norske?",
  "inboxType": "comment",
  "createdAt": "2019-10-04T08:08:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-10-04T08:08:00+00:00",
  "uniqueId": "021018415308",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Fra Lilletorget mot Gamlevegen og nordover",
    "url": "https:\/\/digitaltmuseum.no\/021017344308",
    "uniqueId": "021017344308",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/022ymz7x1R2k?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Statuen av Ludvig Wiese kom p\u00e5 plass i 1927.  Bildet kan tidligst v\u00e6re tatt det \u00e5ret.",
    "author": {
      "name": "\u00d8yvind Sverre Nyfl\u00f8t",
      "imageUrl": null,
      "email": "oynyflot@bbnett.no"
    },
    "createdAt": "2019-09-29T19:37:00+00:00",
    "subject": "Fra Lilletorget mot Gamlevegen og nordover",
    "uniqueId": "99659",
    "status": "open"
  }],
  "title": "Fra Lilletorget mot Gamlevegen og nordover",
  "inboxType": "comment",
  "createdAt": "2019-09-29T19:37:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-29T19:37:00+00:00",
  "uniqueId": "021017344308",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Repro: Drosjer p\u00e5 holdeplass, Lilletorget, Lillehammer.",
    "url": "https:\/\/digitaltmuseum.no\/021017432781",
    "uniqueId": "021017432781",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/0331uU2mT57U?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Statuen av Ludvig Wiese kom p\u00e5 plass i 1927.  Bildet m\u00e5 alts\u00e5 v\u00e6re tatt tidligst det \u00e5ret.",
    "author": {
      "name": "\u00d8yvind Sverre Nyfl\u00f8t",
      "imageUrl": null,
      "email": "oynyflot@bbnett.no"
    },
    "createdAt": "2019-09-29T19:26:00+00:00",
    "subject": "Repro: Drosjer p\u00e5 holdeplass, Lilletorget, Lillehammer.",
    "uniqueId": "99658",
    "status": "open"
  }],
  "title": "Repro: Drosjer p\u00e5 holdeplass, Lilletorget, Lillehammer.",
  "inboxType": "comment",
  "createdAt": "2019-09-29T19:26:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-29T19:26:00+00:00",
  "uniqueId": "021017432781",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Gruppe menn med lastebil ved grustak. Antatt vegarbeidere.  Lastebilen er registrert E -1574, fabrikat Stavern og tilh\u00f8rende Statens Vegvesen i V\u00e5g\u00e5",
    "url": "https:\/\/digitaltmuseum.no\/021018411165",
    "uniqueId": "021018411165",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/03348wYV5mnH?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "E-1574 er den norskbygde Stav\u00e6rn ca. 1920 som Statens veivesen V\u00e5ga hadde. (Den restaurerte bilen p\u00e5 museet Hunderfossen, som er en annen, har dette nr. i dag). Oppl. fra Asbj\u00f8rn Rolseth.\r\n",
    "author": {
      "name": "Ivar Stav",
      "imageUrl": null,
      "email": "ivar.es@online.no"
    },
    "createdAt": "2019-09-27T11:10:00+00:00",
    "subject": "Gruppe menn med lastebil ved grustak. Antatt vegarbeidere.  Lastebilen er registrert E -1574, fabrikat Stavern og tilh\u00f8rende Statens Vegvesen i V\u00e5g\u00e5",
    "uniqueId": "99572",
    "status": "open"
  }],
  "title": "Gruppe menn med lastebil ved grustak. Antatt vegarbeidere.  Lastebilen er registrert E -1574, fabrikat Stavern og tilh\u00f8rende Statens Vegvesen i V\u00e5g\u00e5",
  "inboxType": "comment",
  "createdAt": "2019-09-27T11:10:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-27T11:10:00+00:00",
  "uniqueId": "021018411165",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Hans Larsson og Mari Hansdotter Linds\u00f8 Bergseng med borna Laurits og Anna Bergseng. Hans var fr\u00e5 Upp\u00e5-Linds\u00f8 og gifta seg med Mari fr\u00e5 S\u00f8r-Skotte p\u00e5 Lesjaskog. Dei dreiv Skotte nokre \u00e5r f\u00f8r dei tok over Bergseng p\u00e5 Dovre",
    "url": "https:\/\/digitaltmuseum.no\/021018353029",
    "uniqueId": "021018353029",
    "imageUrl": "https:\/\/dms01.dimu.org\/image\/03347Tgk6TF7?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er Hans Larsson og Mari Hansdotter Linds\u00f8 Bergseng med borna Laurits og Anna Bergseng. Hans var fr\u00e5 Upp\u00e5-Linds\u00f8 og gifta seg med Mari fr\u00e5 S\u00f8r-Skotte p\u00e5 Lesjaskog. Dei dreiv Skotte nokre \u00e5r f\u00f8r dei tok over Bergseng p\u00e5 Dovre. Der budde dei saman med dei tidlegare drivarane Hans og Anne. Hans Larsson Linds\u00f8 var kjent for treskj\u00e6ringa si. ",
    "author": {
      "name": "ola bergseng",
      "imageUrl": null,
      "email": "olabergseng@gmail.com"
    },
    "createdAt": "2019-09-24T09:43:00+00:00",
    "subject": "Hans Larsson og Mari Hansdotter Linds\u00f8 Bergseng med borna Laurits og Anna Bergseng. Hans var fr\u00e5 Upp\u00e5-Linds\u00f8 og gifta seg med Mari fr\u00e5 S\u00f8r-Skotte p\u00e5 Lesjaskog. Dei dreiv Skotte nokre \u00e5r f\u00f8r dei tok over Bergseng p\u00e5 Dovre",
    "uniqueId": "99527",
    "status": "open"
  }],
  "title": "Hans Larsson og Mari Hansdotter Linds\u00f8 Bergseng med borna Laurits og Anna Bergseng. Hans var fr\u00e5 Upp\u00e5-Linds\u00f8 og gifta seg med Mari fr\u00e5 S\u00f8r-Skotte p\u00e5 Lesjaskog. Dei dreiv Skotte nokre \u00e5r f\u00f8r dei tok over Bergseng p\u00e5 Dovre",
  "inboxType": "comment",
  "createdAt": "2019-09-24T09:43:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-24T09:43:00+00:00",
  "uniqueId": "021018353029",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Hans og Anne (f. Teigen fr\u00e5 Lesja), gardbrukarar p\u00e5 Bergseng, Dovre. Dei var  foreldra til Lykkjeguten; ein kjent treskj\u00e6rar\/ sm\u00e5snikker i Dovre som blant anna har skore skipet som heng i Dovre kyrkje.",
    "url": "https:\/\/digitaltmuseum.no\/021018005887",
    "uniqueId": "021018005887",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/0331xxYY6MvB?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er ikkje Jacob og Thor\u00f8 fra Skj\u00e5k. Dette er Hans og Anne (f. Teigen fr\u00e5 Lesja), gardbrukarar p\u00e5 Bergseng, Dovre. Dei var  foreldra til Lykkjeguten; ein kjent treskj\u00e6rar\/ sm\u00e5snikker i Dovre som blant anna har skore skipet som heng i Dovre kyrkje. \u00c5rstalet p\u00e5 fotoet kan stemme. ",
    "author": {
      "name": "Ola Bergseng",
      "imageUrl": null,
      "email": "olabergseng@gmail.com"
    },
    "createdAt": "2019-09-24T09:35:00+00:00",
    "subject": "Hans og Anne (f. Teigen fr\u00e5 Lesja), gardbrukarar p\u00e5 Bergseng, Dovre. Dei var  foreldra til Lykkjeguten; ein kjent treskj\u00e6rar\/ sm\u00e5snikker i Dovre som blant anna har skore skipet som heng i Dovre kyrkje.",
    "uniqueId": "99526",
    "status": "open"
  }],
  "title": "Hans og Anne (f. Teigen fr\u00e5 Lesja), gardbrukarar p\u00e5 Bergseng, Dovre. Dei var  foreldra til Lykkjeguten; ein kjent treskj\u00e6rar\/ sm\u00e5snikker i Dovre som blant anna har skore skipet som heng i Dovre kyrkje.",
  "inboxType": "comment",
  "createdAt": "2019-09-24T09:35:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-24T09:35:00+00:00",
  "uniqueId": "021018005887",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Dette huset l\u00e5 langs Kastrudvegen ved gravplassen \u00f8verst i Leirvika nord for Vingnes, Lillehammer To offiserer i uniform. Huset har  solavskjerming. I bakgrunnen antatt Balberg g\u00e5rd.",
    "url": "https:\/\/digitaltmuseum.no\/021017776849",
    "uniqueId": "021017776849",
    "imageUrl": "https:\/\/dms03.dimu.org\/image\/0231vyF7FJcJ?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "dette huset l\u00e5 langs Kastrudvegen ved gravplassen \u00f8verst i Leirvika nord for Vingnes, Lillehammer",
    "author": {
      "name": "bjorn.riise",
      "imageUrl": null,
      "email": "bjorn.riise@me.com"
    },
    "createdAt": "2019-09-23T19:25:00+00:00",
    "subject": "Dette huset l\u00e5 langs Kastrudvegen ved gravplassen \u00f8verst i Leirvika nord for Vingnes, Lillehammer To offiserer i uniform. Huset har  solavskjerming. I bakgrunnen antatt Balberg g\u00e5rd.",
    "uniqueId": "99501",
    "status": "open"
  }],
  "title": "Dette huset l\u00e5 langs Kastrudvegen ved gravplassen \u00f8verst i Leirvika nord for Vingnes, Lillehammer To offiserer i uniform. Huset har  solavskjerming. I bakgrunnen antatt Balberg g\u00e5rd.",
  "inboxType": "comment",
  "createdAt": "2019-09-23T19:25:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-23T19:25:00+00:00",
  "uniqueId": "021017776849",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Grand Hotel p\u00e5 Otta. To Ford T-biler og mennesker i forgrunnen.",
    "url": "https:\/\/digitaltmuseum.no\/021018405277",
    "uniqueId": "021018405277",
    "imageUrl": "https:\/\/dms05.dimu.org\/image\/03348wRwYcA7?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "To Ford T 1917-19 i forgrunnen, den t.h. med reg.nr. D-152?",
    "author": {
      "name": "Ivar Stav",
      "imageUrl": null,
      "email": "ivar.es@online.no"
    },
    "createdAt": "2019-09-20T07:10:00+00:00",
    "subject": "Grand Hotel p\u00e5 Otta. To Ford T-biler og mennesker i forgrunnen.",
    "uniqueId": "99386",
    "status": "open"
  }],
  "title": "Grand Hotel p\u00e5 Otta. To Ford T-biler og mennesker i forgrunnen.",
  "inboxType": "comment",
  "createdAt": "2019-09-20T07:10:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-20T07:10:00+00:00",
  "uniqueId": "021018405277",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Portrett, helfigur, Oline Holmyren (H\u00f8lmyren)",
    "url": "https:\/\/digitaltmuseum.no\/021017422484",
    "uniqueId": "021017422484",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/0231uTvCQEip?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Oline ellefsdatter F. Brenden f\u00f8r familien flytte til s\u00e6teren for s\u00e5 og flytte til H\u00f8lmyren. Oline giftet seg med Amund Erlandsen Odden, de er folkeregistrert p\u00e5 H\u00f8lmyren i 1900 med 2 d\u00f8tre. Anna og Emma odden.  De emigrerer og tar etternavnet Steen (etter husmannsplassen Stenen der Amund er fra) f\u00e5r mange barn i USA ",
    "author": {
      "name": "Ragnhild Wadahl ",
      "imageUrl": null,
      "email": "Ragnhild@heggerud.no"
    },
    "createdAt": "2019-09-15T22:10:00+00:00",
    "subject": "Portrett, helfigur, Oline Holmyren (H\u00f8lmyren)",
    "uniqueId": "99192",
    "status": "open"
  }],
  "title": "Portrett, helfigur, Oline Holmyren (H\u00f8lmyren)",
  "inboxType": "comment",
  "createdAt": "2019-09-15T22:10:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-15T22:10:00+00:00",
  "uniqueId": "021017422484",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ringebu. Bj\u00f8rgevolden, Bj\u00f8rgeg\u00e5rdene, bildet speilvendt.",
    "url": "https:\/\/digitaltmuseum.no\/011011919098",
    "uniqueId": "011011919098",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/037TJEtrK?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Bilde er speilvendt.",
    "author": {
      "name": "Oddleiv Ringlund",
      "imageUrl": null,
      "email": "oddleiv.ringlund@gudbrandsdalsmusea.no"
    },
    "createdAt": "2019-09-12T06:43:00+00:00",
    "subject": "Ringebu. Bj\u00f8rgevolden, Bj\u00f8rgeg\u00e5rdene, bildet speilvendt.",
    "uniqueId": "99083",
    "status": "open"
  }],
  "title": "Ringebu. Bj\u00f8rgevolden, Bj\u00f8rgeg\u00e5rdene, bildet speilvendt.",
  "inboxType": "comment",
  "createdAt": "2019-09-12T06:43:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-12T06:43:00+00:00",
  "uniqueId": "011011919098",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "K\u00f8benhavn med Det kongelige Bibliotek i K\u00f8benhavn, sett fra haven",
    "url": "https:\/\/digitaltmuseum.no\/021017275264",
    "uniqueId": "021017275264",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/022ymy71GJjz?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Det er Det kongelige Bibliotek i K\u00f8benhavn set fra haven",
    "author": {
      "name": "Bo J\u00f8rgen Nielsen",
      "imageUrl": null,
      "email": "skipperbo@gmail.com"
    },
    "createdAt": "2019-09-03T00:01:00+00:00",
    "subject": "K\u00f8benhavn med Det kongelige Bibliotek i K\u00f8benhavn, sett fra haven",
    "uniqueId": "98835",
    "status": "open"
  }],
  "title": "K\u00f8benhavn med Det kongelige Bibliotek i K\u00f8benhavn, sett fra haven",
  "inboxType": "comment",
  "createdAt": "2019-09-03T00:01:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-09-03T00:01:00+00:00",
  "uniqueId": "021017275264",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Gruppebilde,  Gina E. Holmyren (H\u00f8lmyren) sitter foran, s\u00f8strene Oline til venstre og Anna til h\u00f8gre st\u00e5r bak.",
    "url": "https:\/\/digitaltmuseum.no\/021017422476",
    "uniqueId": "021017422476",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/0331uTvCPuvc?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Gina, Oline og Anna var d\u00f8tre av Elev Olsen f. 1838 og Kari Olsdatter f. 1841 i Varpestuen, begge Nord Fron. Bodde i H\u00f8lmyra - Sk\u00e5bu.",
    "author": {
      "name": "Anne Lise Johansen",
      "imageUrl": null,
      "email": "annelisejohan24@hotmail.com"
    },
    "createdAt": "2019-08-22T09:11:00+00:00",
    "subject": "Gruppebilde,  Gina E. Holmyren (H\u00f8lmyren) sitter foran, s\u00f8strene Oline til venstre og Anna til h\u00f8gre st\u00e5r bak.",
    "uniqueId": "98366",
    "status": "open"
  }],
  "title": "Gruppebilde,  Gina E. Holmyren (H\u00f8lmyren) sitter foran, s\u00f8strene Oline til venstre og Anna til h\u00f8gre st\u00e5r bak.",
  "inboxType": "comment",
  "createdAt": "2019-08-22T09:11:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-22T09:11:00+00:00",
  "uniqueId": "021017422476",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Hovedhuset p\u00e5 Erlandshusom, hjemmet til Vis-Knut fra 1855- 1876 \u00f8verst i Svatsum, Gausdal. En sagkrakk st\u00e5r i front.",
    "url": "https:\/\/digitaltmuseum.no\/021017391614",
    "uniqueId": "021017391614",
    "imageUrl": "https:\/\/dms06.dimu.org\/image\/032ynUfSX7Pd?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Hvem er eier av Erlandshusom ..?",
    "author": {
      "name": "christian b\u00f8rs lind",
      "imageUrl": null,
      "email": "cbl@naturvernforbundet.no"
    },
    "createdAt": "2019-08-14T15:26:00+00:00",
    "subject": "Hovedhuset p\u00e5 Erlandshusom, hjemmet til Vis-Knut fra 1855- 1876 \u00f8verst i Svatsum, Gausdal. En sagkrakk st\u00e5r i front.",
    "uniqueId": "7864",
    "status": "open"
  }],
  "title": "Hovedhuset p\u00e5 Erlandshusom, hjemmet til Vis-Knut fra 1855- 1876 \u00f8verst i Svatsum, Gausdal. En sagkrakk st\u00e5r i front.",
  "inboxType": "inquiry",
  "createdAt": "2019-08-14T15:26:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-14T15:26:00+00:00",
  "uniqueId": "021017391614",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Brunlaug bru over L\u00e5gen ved F\u00e5berg",
    "url": "https:\/\/digitaltmuseum.no\/021018332788",
    "uniqueId": "021018332788",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/03347TEZxoLt?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette bildet er ikke av Myre bru. Kan ikke si hvor, men ikke i F\u00e5vang (Myre) Til opplysning: Myre Bru ble bygget i \u00e5r 1900.",
    "author": {
      "name": "Terje Tromsnes",
      "imageUrl": null,
      "email": "terje@tromsnes.no"
    },
    "createdAt": "2019-08-05T23:18:00+00:00",
    "subject": "Brunlaug bru over L\u00e5gen ved F\u00e5berg",
    "uniqueId": "97652",
    "status": "open"
  }],
  "title": "Brunlaug bru over L\u00e5gen ved F\u00e5berg",
  "inboxType": "comment",
  "createdAt": "2019-08-05T23:18:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-05T23:18:00+00:00",
  "uniqueId": "021018332788",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Vestby kirke",
    "url": "https:\/\/digitaltmuseum.no\/011011920402",
    "uniqueId": "011011920402",
    "imageUrl": "https:\/\/dms05.dimu.org\/image\/027TMAC27?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Vestby kirke",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:44:00+00:00",
    "subject": "Vestby kirke",
    "uniqueId": "97568",
    "status": "open"
  }],
  "title": "Vestby kirke",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:44:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:44:00+00:00",
  "uniqueId": "011011920402",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Gamlebyen kirke i Oslo",
    "url": "https:\/\/digitaltmuseum.no\/011011920378",
    "uniqueId": "011011920378",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/037TMABnx?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Gamlebyen kirke i Oslo",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:43:00+00:00",
    "subject": "Gamlebyen kirke i Oslo",
    "uniqueId": "97567",
    "status": "open"
  }],
  "title": "Gamlebyen kirke i Oslo",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:43:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:43:00+00:00",
  "uniqueId": "011011920378",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "T\u00f8njum kirke i L\u00e6rdal",
    "url": "https:\/\/digitaltmuseum.no\/011011920401",
    "uniqueId": "011011920401",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/047TMAC26?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "T\u00f8njum kirke i L\u00e6rdal",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:36:00+00:00",
    "subject": "T\u00f8njum kirke i L\u00e6rdal",
    "uniqueId": "97565",
    "status": "open"
  }],
  "title": "T\u00f8njum kirke i L\u00e6rdal",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:36:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:36:00+00:00",
  "uniqueId": "011011920401",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Gateparti fra Arendal med Trefoldighetskirken.",
    "url": "https:\/\/digitaltmuseum.no\/021017995443",
    "uniqueId": "021017995443",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/0231xxKbxeNC?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Arendals kirke kalles Trefoldighetskirken.",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:33:00+00:00",
    "subject": "Gateparti fra Arendal med Trefoldighetskirken.",
    "uniqueId": "97564",
    "status": "open"
  }],
  "title": "Gateparti fra Arendal med Trefoldighetskirken.",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:33:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:33:00+00:00",
  "uniqueId": "021017995443",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Motiv fra Arendal med Arendal kirke.",
    "url": "https:\/\/digitaltmuseum.no\/021017995444",
    "uniqueId": "021017995444",
    "imageUrl": "https:\/\/dms05.dimu.org\/image\/0231xxKbxeST?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Arendals kirke kalles Trefoldighetskirken.",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:33:00+00:00",
    "subject": "Motiv fra Arendal med Arendal kirke.",
    "uniqueId": "97563",
    "status": "open"
  }],
  "title": "Motiv fra Arendal med Arendal kirke.",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:33:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:33:00+00:00",
  "uniqueId": "021017995444",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "S\u00f8dorp kirke, Nord-Fron: Sakkeus, \u00abDen bodferdige Tolder\u00bb p\u00e5 \u00f8stportalen i S\u00f8dorp kirke",
    "url": "https:\/\/digitaltmuseum.no\/021017275157",
    "uniqueId": "021017275157",
    "imageUrl": "https:\/\/dms01.dimu.org\/image\/022ymy71FyBa?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "\u00abDen bodferdige Tolder\u00bb (alts\u00e5 Sakkeus) p\u00e5 \u00f8stportalen i S\u00f8dorp kirke",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:32:00+00:00",
    "subject": "S\u00f8dorp kirke, Nord-Fron: Sakkeus, \u00abDen bodferdige Tolder\u00bb p\u00e5 \u00f8stportalen i S\u00f8dorp kirke",
    "uniqueId": "97562",
    "status": "open"
  }],
  "title": "S\u00f8dorp kirke, Nord-Fron: Sakkeus, \u00abDen bodferdige Tolder\u00bb p\u00e5 \u00f8stportalen i S\u00f8dorp kirke",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:32:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:32:00+00:00",
  "uniqueId": "021017275157",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "S\u00f8dorp kirke, Nord-Fron, prekestol, d\u00f8pefont",
    "url": "https:\/\/digitaltmuseum.no\/021017275155",
    "uniqueId": "021017275155",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/022ymy71FyBY?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "S\u00f8dorp kirke",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:30:00+00:00",
    "subject": "S\u00f8dorp kirke, Nord-Fron, prekestol, d\u00f8pefont",
    "uniqueId": "97561",
    "status": "open"
  }],
  "title": "S\u00f8dorp kirke, Nord-Fron, prekestol, d\u00f8pefont",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:30:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:30:00+00:00",
  "uniqueId": "021017275155",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Altertavla i S\u00f8dorp kirke, Nord-Fron",
    "url": "https:\/\/digitaltmuseum.no\/021017275154",
    "uniqueId": "021017275154",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/032ymy71FyBV?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "S\u00f8dorp kirke",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:30:00+00:00",
    "subject": "Altertavla i S\u00f8dorp kirke, Nord-Fron",
    "uniqueId": "97560",
    "status": "open"
  }],
  "title": "Altertavla i S\u00f8dorp kirke, Nord-Fron",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:30:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:30:00+00:00",
  "uniqueId": "021017275154",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Tettbebyggelsen p\u00e5 Voss med kirken",
    "url": "https:\/\/digitaltmuseum.no\/011011920471",
    "uniqueId": "011011920471",
    "imageUrl": "https:\/\/dms10.dimu.org\/image\/017TMAXGo?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Voss",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:28:00+00:00",
    "subject": "Tettbebyggelsen p\u00e5 Voss med kirken",
    "uniqueId": "97559",
    "status": "open"
  }],
  "title": "Tettbebyggelsen p\u00e5 Voss med kirken",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:28:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:28:00+00:00",
  "uniqueId": "011011920471",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Slidre kirke, popul\u00e6rt kalt Slidredomen, tilsynelatende f\u00f8r siste utvidelse av sakristiet s\u00f8r for koret",
    "url": "https:\/\/digitaltmuseum.no\/011011920459",
    "uniqueId": "011011920459",
    "imageUrl": "https:\/\/dms01.dimu.org\/image\/047TMAXCN?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Formodentlig (Vestre) Slidre kirke, popul\u00e6rt kalt Slidredomen, tilsynelatende f\u00f8r siste utvidelse av sakristiet s\u00f8r for koret.",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:26:00+00:00",
    "subject": "Slidre kirke, popul\u00e6rt kalt Slidredomen, tilsynelatende f\u00f8r siste utvidelse av sakristiet s\u00f8r for koret",
    "uniqueId": "97558",
    "status": "open"
  }],
  "title": "Slidre kirke, popul\u00e6rt kalt Slidredomen, tilsynelatende f\u00f8r siste utvidelse av sakristiet s\u00f8r for koret",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:26:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:26:00+00:00",
  "uniqueId": "011011920459",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Borgund kirke i \u00c5lesund",
    "url": "https:\/\/digitaltmuseum.no\/011011920386",
    "uniqueId": "011011920386",
    "imageUrl": "https:\/\/dms03.dimu.org\/image\/027TMABsM?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Borgund kirke i \u00c5lesund kommune",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:14:00+00:00",
    "subject": "Borgund kirke i \u00c5lesund",
    "uniqueId": "97556",
    "status": "open"
  }],
  "title": "Borgund kirke i \u00c5lesund",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:14:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:14:00+00:00",
  "uniqueId": "011011920386",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "\u00d8rsta kirke f\u00f8r svalen ble ombygget i 1953",
    "url": "https:\/\/digitaltmuseum.no\/011011920470",
    "uniqueId": "011011920470",
    "imageUrl": "https:\/\/dms08.dimu.org\/image\/017TMAXGn?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er \u00d8rsta kirke f\u00f8r svalen ble ombygget i 1953.",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:09:00+00:00",
    "subject": "\u00d8rsta kirke f\u00f8r svalen ble ombygget i 1953",
    "uniqueId": "97555",
    "status": "open"
  }],
  "title": "\u00d8rsta kirke f\u00f8r svalen ble ombygget i 1953",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:09:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:09:00+00:00",
  "uniqueId": "011011920470",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Eidsberg kirke",
    "url": "https:\/\/digitaltmuseum.no\/011011920467",
    "uniqueId": "011011920467",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/037TMAXGj?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er Eidsberg kirke.",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:04:00+00:00",
    "subject": "Eidsberg kirke",
    "uniqueId": "97554",
    "status": "open"
  }],
  "title": "Eidsberg kirke",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:04:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:04:00+00:00",
  "uniqueId": "011011920467",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "S\u00e5ner kirke",
    "url": "https:\/\/digitaltmuseum.no\/011011920396",
    "uniqueId": "011011920396",
    "imageUrl": "https:\/\/dms08.dimu.org\/image\/037TMABwm?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er ikke en steinkirke, men en trekirke. Det dreier seg om tredje inkarnasjon av S\u00e5ner kirke (Vestby kommune). Den ble vigslet den 12. mars 1880 og brant ned til grunnen etter \u00e5 ha blitt p\u00e5tent den 25. mai 1995.",
    "author": {
      "name": "Jan-Tore Egge",
      "imageUrl": null,
      "email": "jtegge@online.no"
    },
    "createdAt": "2019-08-02T18:03:00+00:00",
    "subject": "S\u00e5ner kirke",
    "uniqueId": "97553",
    "status": "open"
  }],
  "title": "S\u00e5ner kirke",
  "inboxType": "comment",
  "createdAt": "2019-08-02T18:03:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-08-02T18:03:00+00:00",
  "uniqueId": "011011920396",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ola Aspen st\u00e5r med fiskegarn ved siden av Furus\u00e6terbua vid Flaksj\u00f8en, Venabufjellet.",
    "url": "https:\/\/digitaltmuseum.no\/021017391258",
    "uniqueId": "021017391258",
    "imageUrl": "https:\/\/dms10.dimu.org\/image\/022ynUZ8NBye?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Ola Aspen st\u00e5r framfor Furus\u00e6terbua vid Flaksj\u00f8en",
    "author": {
      "name": "Vibeke Moen",
      "imageUrl": null,
      "email": "vibekemoen@hotmail.com"
    },
    "createdAt": "2019-07-30T16:09:00+00:00",
    "subject": "Ola Aspen st\u00e5r med fiskegarn ved siden av Furus\u00e6terbua vid Flaksj\u00f8en, Venabufjellet.",
    "uniqueId": "97454",
    "status": "open"
  }],
  "title": "Ola Aspen st\u00e5r med fiskegarn ved siden av Furus\u00e6terbua vid Flaksj\u00f8en, Venabufjellet.",
  "inboxType": "comment",
  "createdAt": "2019-07-30T16:09:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-30T16:09:00+00:00",
  "uniqueId": "021017391258",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ringebu. Flaksj\u00f8en. Jegere, tre menn med to hunder, foran Nils Anderssons hytte.",
    "url": "https:\/\/digitaltmuseum.no\/021018332923",
    "uniqueId": "021018332923",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/03347TEZy94C?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Gruppen sitterp\u00e5 trappen foran Nils Anderssons hytte ved Flakssj\u00f8en. Mannen til h\u00f8yre i bildet er Anders Andersson. ",
    "author": {
      "name": "Vibeke Moen",
      "imageUrl": null,
      "email": "vibekemoen@hotmail.com"
    },
    "createdAt": "2019-07-30T08:23:00+00:00",
    "subject": "Ringebu. Flaksj\u00f8en. Jegere, tre menn med to hunder, foran Nils Anderssons hytte.",
    "uniqueId": "97441",
    "status": "open"
  }],
  "title": "Ringebu. Flaksj\u00f8en. Jegere, tre menn med to hunder, foran Nils Anderssons hytte.",
  "inboxType": "comment",
  "createdAt": "2019-07-30T08:23:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-30T08:23:00+00:00",
  "uniqueId": "021018332923",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ringebu. Flaksj\u00f8en. \"Jaktselskap\", fire menn rundt bordet i \"Hygga\"",
    "url": "https:\/\/digitaltmuseum.no\/021018332928",
    "uniqueId": "021018332928",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/03347TEZy98X?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Interi\u00f8rbilde fra \" Hygga\" , personen nr 2.fra venstre er Anders Andersson.",
    "author": {
      "name": "Vibeke Moen",
      "imageUrl": null,
      "email": "vibekemoen@hotmail.com"
    },
    "createdAt": "2019-07-30T08:19:00+00:00",
    "subject": "Ringebu. Flaksj\u00f8en. \"Jaktselskap\", fire menn rundt bordet i \"Hygga\"",
    "uniqueId": "97440",
    "status": "open"
  }],
  "title": "Ringebu. Flaksj\u00f8en. \"Jaktselskap\", fire menn rundt bordet i \"Hygga\"",
  "inboxType": "comment",
  "createdAt": "2019-07-30T08:19:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-30T08:19:00+00:00",
  "uniqueId": "021018332928",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ved Furus\u00e6terbua, Flaksj\u00f8en i Ringebufjellet.  Fra h\u00f8yre Hans og Ingeborg Furus\u00e6ter og Ola Aspen. Til venstre i bildet sitter Nils Andersson og hustrun Ingeborg Andersson. De bygde 1921 hytta \"Hygga\" p\u00e5 dette stedet.",
    "url": "https:\/\/digitaltmuseum.no\/021017391116",
    "uniqueId": "021017391116",
    "imageUrl": "https:\/\/dms02.dimu.org\/image\/032ynUZ8MX1i?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Til venstre i bildet sitter Nils Andersson og hustrun Ingeborg Andersson.De bygde 1921 hytta \"Hygga\" p\u00e5 dette stedet. Hygga finns med p\u00e5 flere bilder i museets samling.",
    "author": {
      "name": "Vibeke Moen",
      "imageUrl": null,
      "email": "vibekemoen@hotmail.com"
    },
    "createdAt": "2019-07-30T08:07:00+00:00",
    "subject": "Ved Furus\u00e6terbua, Flaksj\u00f8en i Ringebufjellet.  Fra h\u00f8yre Hans og Ingeborg Furus\u00e6ter og Ola Aspen. Til venstre i bildet sitter Nils Andersson og hustrun Ingeborg Andersson. De bygde 1921 hytta \"Hygga\" p\u00e5 dette stedet.",
    "uniqueId": "97439",
    "status": "open"
  }],
  "title": "Ved Furus\u00e6terbua, Flaksj\u00f8en i Ringebufjellet.  Fra h\u00f8yre Hans og Ingeborg Furus\u00e6ter og Ola Aspen. Til venstre i bildet sitter Nils Andersson og hustrun Ingeborg Andersson. De bygde 1921 hytta \"Hygga\" p\u00e5 dette stedet.",
  "inboxType": "comment",
  "createdAt": "2019-07-30T08:07:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-30T08:07:00+00:00",
  "uniqueId": "021017391116",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Lise Johannesdatter Skoug f\u00f8dt Saksum (1828-1915). Hun var datter av Johannes Fredriksen Saksum (fra Hov i Snertingdal) og Eli Amundsdatter Olstad fra Gausdal. Gift 1.gang med Hans Eriksen Skoug (1810-55) og 2.gang med hans bror Jens Eriksen Skoug (1824-74).",
    "url": "https:\/\/digitaltmuseum.no\/021017448805",
    "uniqueId": "021017448805",
    "imageUrl": "https:\/\/dms01.dimu.org\/image\/0231uUFvwMmk?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er Lise Johannesdatter Skoug f\u00f8dt Saksum (1828-1915). Hun var datter av Johannes Fredriksen Saksum (fra Hov i Snertingdal) og Eli Amundsdatter Olstad fra Gausdal. Gift 1.gang med Hans Eriksen Skoug (1810-55) og 2.gang med hans bror Jens Eriksen Skoug (1824-74).",
    "author": {
      "name": "Hans Tomter",
      "imageUrl": null,
      "email": "tomterhans1@gmail.com"
    },
    "createdAt": "2019-07-26T09:25:00+00:00",
    "subject": "Lise Johannesdatter Skoug f\u00f8dt Saksum (1828-1915). Hun var datter av Johannes Fredriksen Saksum (fra Hov i Snertingdal) og Eli Amundsdatter Olstad fra Gausdal. Gift 1.gang med Hans Eriksen Skoug (1810-55) og 2.gang med hans bror Jens Eriksen Skoug (1824-74).",
    "uniqueId": "97303",
    "status": "open"
  }],
  "title": "Lise Johannesdatter Skoug f\u00f8dt Saksum (1828-1915). Hun var datter av Johannes Fredriksen Saksum (fra Hov i Snertingdal) og Eli Amundsdatter Olstad fra Gausdal. Gift 1.gang med Hans Eriksen Skoug (1810-55) og 2.gang med hans bror Jens Eriksen Skoug (1824-74).",
  "inboxType": "comment",
  "createdAt": "2019-07-26T09:25:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-26T09:25:00+00:00",
  "uniqueId": "021017448805",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Thing",
    "description": "",
    "title": "Maleri p\u00e5 lerret med gyllen ramme i tre.",
    "url": "https:\/\/digitaltmuseum.no\/011022411467",
    "uniqueId": "011022411467",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/0177e8jtP?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Hei! Jeg har et maleri som er malt fra samme sted med samme motiv og samme signatur, fra et annet st\u00e5sted p\u00e5 den samme seteren. Hvor kan jeg henvende meg for \u00e5 f\u00e5 vite mer om bildet, kunstneren og verdien av det?",
    "author": {
      "name": "Hanne Larsen",
      "imageUrl": null,
      "email": "hanne.larsen@gmail.com"
    },
    "createdAt": "2019-07-25T06:32:00+00:00",
    "subject": "Maleri p\u00e5 lerret med gyllen ramme i tre.",
    "uniqueId": "7759",
    "status": "open"
  }],
  "title": "Maleri p\u00e5 lerret med gyllen ramme i tre.",
  "inboxType": "inquiry",
  "createdAt": "2019-07-25T06:32:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-25T06:32:00+00:00",
  "uniqueId": "011022411467",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Nord-Fron. Utsikt nordover fra et sted litt s\u00f8r for oppkj\u00f8ringa til Gardvegen i Kvam. Garden Holmen (H\u00f8lmen) ligger like til venstre, utenfor bildet. Mot Engum (Toksesletten) og Teigkampen.",
    "url": "https:\/\/digitaltmuseum.no\/021018328105",
    "uniqueId": "021018328105",
    "imageUrl": "https:\/\/dms02.dimu.org\/image\/03347T82RJPc?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Bildet ble ikke tatt fra Brekka. Det er tatt fra et punkt litt s\u00f8r for oppkj\u00f8ringa til Gardvegen i Kvam. Garden Holmen (eller H\u00f8lmen som den heter) ligger like til venstre, utenfor bildet. ",
    "author": {
      "name": "Per Fredriksen",
      "imageUrl": null,
      "email": "pefredri@bbnett.no"
    },
    "createdAt": "2019-07-24T05:49:00+00:00",
    "subject": "Nord-Fron. Utsikt nordover fra et sted litt s\u00f8r for oppkj\u00f8ringa til Gardvegen i Kvam. Garden Holmen (H\u00f8lmen) ligger like til venstre, utenfor bildet. Mot Engum (Toksesletten) og Teigkampen.",
    "uniqueId": "97226",
    "status": "open"
  }],
  "title": "Nord-Fron. Utsikt nordover fra et sted litt s\u00f8r for oppkj\u00f8ringa til Gardvegen i Kvam. Garden Holmen (H\u00f8lmen) ligger like til venstre, utenfor bildet. Mot Engum (Toksesletten) og Teigkampen.",
  "inboxType": "comment",
  "createdAt": "2019-07-24T05:49:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-24T05:49:00+00:00",
  "uniqueId": "021018328105",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ingebret O. Prestangen f\u00f8dt 1865 i Ringebu. Gift 1895 med Ingeborg T. Brenden fra Kvam. De fikk \u00e9n datter, Marie f\u00f8dt 31. mars 1896. Ved folketellingen i 1910 bodde mor og datter p\u00e5 hennes hjemsted Brenna i Kvam. Mannen var i Amerika p\u00e5 jernbanearbeid.",
    "url": "https:\/\/digitaltmuseum.no\/011012288337",
    "uniqueId": "011012288337",
    "imageUrl": "https:\/\/dms02.dimu.org\/image\/0331wy1Ruxyn?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Ingebret O. Prestangen f\u00f8dt 1865 i Ringebu. Gift 1895 med Ingeborg T. Brenden fra Kvam. De fikk \u00e9n datter, Marie f\u00f8dt 31. mars 1896. Ved FT 1910 bodde mor og datter p\u00e5 hennes hjemsted Brenna i Kvam. Mannen var i Amerika p\u00e5 jernbanearbeid.",
    "author": {
      "name": "Per Fredriksen",
      "imageUrl": null,
      "email": "pefredri@bbnett.no"
    },
    "createdAt": "2019-07-22T09:49:00+00:00",
    "subject": "Ingebret O. Prestangen f\u00f8dt 1865 i Ringebu. Gift 1895 med Ingeborg T. Brenden fra Kvam. De fikk \u00e9n datter, Marie f\u00f8dt 31. mars 1896. Ved folketellingen i 1910 bodde mor og datter p\u00e5 hennes hjemsted Brenna i Kvam. Mannen var i Amerika p\u00e5 jernbanearbeid.",
    "uniqueId": "97166",
    "status": "open"
  }],
  "title": "Ingebret O. Prestangen f\u00f8dt 1865 i Ringebu. Gift 1895 med Ingeborg T. Brenden fra Kvam. De fikk \u00e9n datter, Marie f\u00f8dt 31. mars 1896. Ved folketellingen i 1910 bodde mor og datter p\u00e5 hennes hjemsted Brenna i Kvam. Mannen var i Amerika p\u00e5 jernbanearbeid.",
  "inboxType": "comment",
  "createdAt": "2019-07-22T09:49:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-22T09:49:00+00:00",
  "uniqueId": "011012288337",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Ole Knipen med rive utenfor en g\u00e5rd. Dette er mest sannsynlig Ole Nilsen Knipen 1805-1901. P\u00e5 sine eldre dager livn\u00e6rte han seg ved \u00e5 lage river.",
    "url": "https:\/\/digitaltmuseum.no\/011012289050",
    "uniqueId": "011012289050",
    "imageUrl": "https:\/\/dms08.dimu.org\/image\/0331wy1NyLsZ?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Jeg vet ikke hvor dere har navnet Ole Halvorsen Knipen fra. I \u00e5rene 1825-27 var det kun f\u00f8dt \u00e9n Ole med far Haldor i Kvam. Han d\u00f8de i 1895. Bildet fra 1897 er mest sannsynlig av Ole Nilsen Knipen 1805-1901. P\u00e5 sine eldre dager livn\u00e6rte han seg ved \u00e5 lage river.",
    "author": {
      "name": "Per Fredriksen",
      "imageUrl": null,
      "email": "pefredri@bbnett.no"
    },
    "createdAt": "2019-07-22T08:57:00+00:00",
    "subject": "Ole Knipen med rive utenfor en g\u00e5rd. Dette er mest sannsynlig Ole Nilsen Knipen 1805-1901. P\u00e5 sine eldre dager livn\u00e6rte han seg ved \u00e5 lage river.",
    "uniqueId": "97161",
    "status": "open"
  }],
  "title": "Ole Knipen med rive utenfor en g\u00e5rd. Dette er mest sannsynlig Ole Nilsen Knipen 1805-1901. P\u00e5 sine eldre dager livn\u00e6rte han seg ved \u00e5 lage river.",
  "inboxType": "comment",
  "createdAt": "2019-07-22T08:57:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-22T08:57:00+00:00",
  "uniqueId": "011012289050",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Aslaug Berge - fotografens svigerdatter - med barnevogn",
    "url": "https:\/\/digitaltmuseum.no\/021017344198",
    "uniqueId": "021017344198",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/032ymz7va8D6?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Hei! Dette bildet er av Aslaug Berge, f\u00f8dt Falnes. Hun er gift med Gunnar Berge, s\u00f8nn av fotografen Marius Berge. I barnevogna ligger moren min Toril Berge, f\u00f8dt juli 1951",
    "author": {
      "name": "Cecilie Meyer",
      "imageUrl": null,
      "email": "cecilie_meyer@hotmail.com"
    },
    "createdAt": "2019-07-08T19:47:00+00:00",
    "subject": "Aslaug Berge - fotografens svigerdatter - med barnevogn",
    "uniqueId": "7683",
    "status": "open"
  }],
  "title": "Aslaug Berge - fotografens svigerdatter - med barnevogn",
  "inboxType": "inquiry",
  "createdAt": "2019-07-08T19:47:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-08T19:47:00+00:00",
  "uniqueId": "021017344198",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "To sm\u00e5 piker p\u00e5 tunet utenfor Hjerkinn fjellstue p\u00e5 Dovrefjell. Den eldste er Signe Hjerkinn f\u00f8dt 1899 og Tora f 1907",
    "url": "https:\/\/digitaltmuseum.no\/021017312056",
    "uniqueId": "021017312056",
    "imageUrl": "https:\/\/dms08.dimu.org\/image\/022ymytwRQXr?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Bilde viser Signe (t.v.) f\u00f8dt 20.06.99. Vi tror det er Tora, ikke Astrid til h\u00f8yre grunnet aldersforskjellen. Tora er f\u00f8dt 18.12.06, Astrid er f\u00f8dt 09.10.10. ",
    "author": {
      "name": "Tyri Granviken Solvoll",
      "imageUrl": null,
      "email": "tyrisolvoll@hotmail.com"
    },
    "createdAt": "2019-07-08T15:59:00+00:00",
    "subject": "To sm\u00e5 piker p\u00e5 tunet utenfor Hjerkinn fjellstue p\u00e5 Dovrefjell. Den eldste er Signe Hjerkinn f\u00f8dt 1899 og Tora f 1907",
    "uniqueId": "7679",
    "status": "open"
  }],
  "title": "To sm\u00e5 piker p\u00e5 tunet utenfor Hjerkinn fjellstue p\u00e5 Dovrefjell. Den eldste er Signe Hjerkinn f\u00f8dt 1899 og Tora f 1907",
  "inboxType": "inquiry",
  "createdAt": "2019-07-08T15:59:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-08T15:59:00+00:00",
  "uniqueId": "021017312056",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Kort: Nord Fron. Nr 3 fra venstre 1. rekke: Ole Iversen Teige (1858-1931) fra Kvam, tidligere ordf\u00f8rer i Nord-Fron og stortingspolitiker. Nr 7 fra venstre 1. rekke: Lensmann Haanshus.",
    "url": "https:\/\/digitaltmuseum.no\/011011918018",
    "uniqueId": "011011918018",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/0231wxfoKUhd?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Nr. 3 f.v. er ikke Ole Terje. Det er Ole Iversen Teige (1858-1931) fra Kvam. Han var gardbruker p\u00e5 Hov i Ruste. (Vinstra) Tidl. ordf\u00f8rer i Nord-Fron og stortingspolitiker.",
    "author": {
      "name": "Per Fredriksen",
      "imageUrl": null,
      "email": "pefredri@bbnett.no"
    },
    "createdAt": "2019-07-04T09:10:00+00:00",
    "subject": "Kort: Nord Fron. Nr 3 fra venstre 1. rekke: Ole Iversen Teige (1858-1931) fra Kvam, tidligere ordf\u00f8rer i Nord-Fron og stortingspolitiker. Nr 7 fra venstre 1. rekke: Lensmann Haanshus.",
    "uniqueId": "96656",
    "status": "open"
  }],
  "title": "Kort: Nord Fron. Nr 3 fra venstre 1. rekke: Ole Iversen Teige (1858-1931) fra Kvam, tidligere ordf\u00f8rer i Nord-Fron og stortingspolitiker. Nr 7 fra venstre 1. rekke: Lensmann Haanshus.",
  "inboxType": "comment",
  "createdAt": "2019-07-04T09:10:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-04T09:10:00+00:00",
  "uniqueId": "011011918018",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Familien S\u00e6tre fra Kvam, Nord-Fron. Jon R. S\u00e6tre (1862-1954) var skolestyrer p\u00e5 Kvam skole, gift 1897 med Karen Marie Teige (1873-1955). Den st\u00f8rste jenta er Ragnfrid (1898-1992), den andre Margit (1910-1997). Gutten til venstre er trolig Sverre (1902-1974), Ivar (1899-1991) bak til venstre og til h\u00f8yre Olav (1906-1989). Jon var ogs\u00e5 klokker i bygda.",
    "url": "https:\/\/digitaltmuseum.no\/011011918017",
    "uniqueId": "011011918017",
    "imageUrl": "https:\/\/dms08.dimu.org\/image\/027TGjEEn?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Dette er familien S\u00e6tre fra Kvam, Nord-Fron. Jon R. S\u00e6tre (1862-1954) var skolestyrer p\u00e5 Kvam skole. Gift 1897 med Karen Marie Teige (1873-1955). Den st\u00f8rste jenta er Ragnfrid (1898-1992). Margit (1910-1997) hette den andre. Jeg mener at gutten til venstre er Sverre (1902-1974), han bak Ivar (1899-1991) og til h\u00f8yre Olav (1906-1989). Jon var ogs\u00e5 klokker i bygda.",
    "author": {
      "name": "Per Fredriksen",
      "imageUrl": null,
      "email": "pefredri@bbnett.no"
    },
    "createdAt": "2019-07-04T08:59:00+00:00",
    "subject": "Familien S\u00e6tre fra Kvam, Nord-Fron. Jon R. S\u00e6tre (1862-1954) var skolestyrer p\u00e5 Kvam skole, gift 1897 med Karen Marie Teige (1873-1955). Den st\u00f8rste jenta er Ragnfrid (1898-1992), den andre Margit (1910-1997). Gutten til venstre er trolig Sverre (1902-1974), Ivar (1899-1991) bak til venstre og til h\u00f8yre Olav (1906-1989). Jon var ogs\u00e5 klokker i bygda.",
    "uniqueId": "96655",
    "status": "open"
  }],
  "title": "Familien S\u00e6tre fra Kvam, Nord-Fron. Jon R. S\u00e6tre (1862-1954) var skolestyrer p\u00e5 Kvam skole, gift 1897 med Karen Marie Teige (1873-1955). Den st\u00f8rste jenta er Ragnfrid (1898-1992), den andre Margit (1910-1997). Gutten til venstre er trolig Sverre (1902-1974), Ivar (1899-1991) bak til venstre og til h\u00f8yre Olav (1906-1989). Jon var ogs\u00e5 klokker i bygda.",
  "inboxType": "comment",
  "createdAt": "2019-07-04T08:59:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-07-04T08:59:00+00:00",
  "uniqueId": "011011918017",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Fra dekket p\u00e5 fergen \"Geiranger\" - Arnfinn Kr\u00e5b\u00f8l til h\u00f8yre",
    "url": "https:\/\/digitaltmuseum.no\/021018307132",
    "uniqueId": "021018307132",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/02347SfoN2JL?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Arnfinn Kr\u00e5b\u00f8l til h\u00f8yre p\u00e5 bildet",
    "author": {
      "name": "H\u00e5kon Kr\u00e5b\u00f8l",
      "imageUrl": null,
      "email": "haakon.kraaboel@gmail.com"
    },
    "createdAt": "2019-06-04T21:43:00+00:00",
    "subject": "Fra dekket p\u00e5 fergen \"Geiranger\" - Arnfinn Kr\u00e5b\u00f8l til h\u00f8yre",
    "uniqueId": "7512",
    "status": "open"
  }],
  "title": "Fra dekket p\u00e5 fergen \"Geiranger\" - Arnfinn Kr\u00e5b\u00f8l til h\u00f8yre",
  "inboxType": "inquiry",
  "createdAt": "2019-06-04T21:43:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-06-04T21:43:00+00:00",
  "uniqueId": "021018307132",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Arnfinn Kr\u00e5b\u00f8l p\u00e5 et tettsted p\u00e5 Vestlandet",
    "url": "https:\/\/digitaltmuseum.no\/021018307126",
    "uniqueId": "021018307126",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/03347SfoN2JF?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Arnfinn Kr\u00e5b\u00f8l, og hans Ford v8 helt til venstre p\u00e5 bildet",
    "author": {
      "name": "H\u00e5kon Kr\u00e5b\u00f8l",
      "imageUrl": null,
      "email": "haakon.kraaboel@gmail.com"
    },
    "createdAt": "2019-06-04T21:40:00+00:00",
    "subject": "Arnfinn Kr\u00e5b\u00f8l p\u00e5 et tettsted p\u00e5 Vestlandet",
    "uniqueId": "7511",
    "status": "open"
  }],
  "title": "Arnfinn Kr\u00e5b\u00f8l p\u00e5 et tettsted p\u00e5 Vestlandet",
  "inboxType": "inquiry",
  "createdAt": "2019-06-04T21:40:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-06-04T21:40:00+00:00",
  "uniqueId": "021018307126",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Arnfinn Kr\u00e5b\u00f8l og ukjent kvinne p\u00e5 Vestlandstur",
    "url": "https:\/\/digitaltmuseum.no\/021018307095",
    "uniqueId": "021018307095",
    "imageUrl": "https:\/\/dms04.dimu.org\/image\/03347SfoN251?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Vestlandstur, Arnfinn Kr\u00e5b\u00f8l ",
    "author": {
      "name": "H\u00e5kon Kr\u00e5b\u00f8l",
      "imageUrl": null,
      "email": "haakon.kraaboel@gmail.com"
    },
    "createdAt": "2019-06-04T21:37:00+00:00",
    "subject": "Arnfinn Kr\u00e5b\u00f8l og ukjent kvinne p\u00e5 Vestlandstur",
    "uniqueId": "7508",
    "status": "open"
  }],
  "title": "Arnfinn Kr\u00e5b\u00f8l og ukjent kvinne p\u00e5 Vestlandstur",
  "inboxType": "inquiry",
  "createdAt": "2019-06-04T21:37:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-06-04T21:37:00+00:00",
  "uniqueId": "021018307095",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Parti fra Vestlandet, stopp langs vegen, Arnfinn Kr\u00e5b\u00f8l st\u00e5r foran sin Ford V8 1936-modell E-8175",
    "url": "https:\/\/digitaltmuseum.no\/021018307108",
    "uniqueId": "021018307108",
    "imageUrl": "https:\/\/dms07.dimu.org\/image\/02347SfoN2Dn?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Arnfinn Kr\u00e5b\u00f8l st\u00e5r foran sin Ford v8",
    "author": {
      "name": "H\u00e5kon Kr\u00e5b\u00f8l",
      "imageUrl": null,
      "email": "haakon.kraaboel@gmail.com"
    },
    "createdAt": "2019-06-04T21:25:00+00:00",
    "subject": "Parti fra Vestlandet, stopp langs vegen, Arnfinn Kr\u00e5b\u00f8l st\u00e5r foran sin Ford V8 1936-modell E-8175",
    "uniqueId": "7504",
    "status": "open"
  }],
  "title": "Parti fra Vestlandet, stopp langs vegen, Arnfinn Kr\u00e5b\u00f8l st\u00e5r foran sin Ford V8 1936-modell E-8175",
  "inboxType": "inquiry",
  "createdAt": "2019-06-04T21:25:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-06-04T21:25:00+00:00",
  "uniqueId": "021018307108",
  "label": null,
  "ownerId": 1
}, {
  "appName": "DM",
  "attachments": [{
    "documentType": "Photograph",
    "description": "",
    "title": "Lillehammer, F\u00e5berg, Flyfoto, F\u00e5berg tettsted, mot nord-\u00f8st. De to \u00f8verste bygningene til h\u00f8yre er Gudbrandsdalsvegen 520 med bruksnavn Bleikevolden og Gudbrandsdalsvegen 522 med bruksnavn Toftebu. Det \u00f8verste huset til venstre (lengst nord i Gudbransdalsvegen) er Gudbransdalsvegen 524 med bruksnavn Angeli. I nedre h\u00f8yre hj\u00f8rne er Carl Haugens veg 5B med bruksnavn Kj\u00e6rstad",
    "url": "https:\/\/digitaltmuseum.no\/021016962401",
    "uniqueId": "021016962401",
    "imageUrl": "https:\/\/dms09.dimu.org\/image\/032yjyguU9ho?dimension=57x57-crop"
  }],
  "messages": [{
    "message": "Det \u00f8verste huset til venstre (lengst nord i Gudbransdalsvegen) er Gudbransdalsvegen 524 med bruksnavn Angeli.",
    "author": {
      "name": "Magnar Johannessen",
      "imageUrl": null,
      "email": "mjohannessen@online.no"
    },
    "createdAt": "2019-06-04T11:58:00+00:00",
    "subject": "Lillehammer, F\u00e5berg, Flyfoto, F\u00e5berg tettsted, mot nord-\u00f8st. De to \u00f8verste bygningene til h\u00f8yre er Gudbrandsdalsvegen 520 med bruksnavn Bleikevolden og Gudbrandsdalsvegen 522 med bruksnavn Toftebu. Det \u00f8verste huset til venstre (lengst nord i Gudbransdalsvegen) er Gudbransdalsvegen 524 med bruksnavn Angeli. I nedre h\u00f8yre hj\u00f8rne er Carl Haugens veg 5B med bruksnavn Kj\u00e6rstad",
    "uniqueId": "7499",
    "status": "open"
  }],
  "title": "Lillehammer, F\u00e5berg, Flyfoto, F\u00e5berg tettsted, mot nord-\u00f8st. De to \u00f8verste bygningene til h\u00f8yre er Gudbrandsdalsvegen 520 med bruksnavn Bleikevolden og Gudbrandsdalsvegen 522 med bruksnavn Toftebu. Det \u00f8verste huset til venstre (lengst nord i Gudbransdalsvegen) er Gudbransdalsvegen 524 med bruksnavn Angeli. I nedre h\u00f8yre hj\u00f8rne er Carl Haugens veg 5B med bruksnavn Kj\u00e6rstad",
  "inboxType": "inquiry",
  "createdAt": "2019-06-04T11:58:00+00:00",
  "ownerName": "MH",
  "appColor": appColor,
  "updatedAt": "2019-06-04T11:58:00+00:00",
  "uniqueId": "021016962401",
  "label": null,
  "ownerId": 1
}];